<script>
import {GET_USER_BY_PHONE} from "@/core/services/store/user/users.module";
import {ADD_NEW_TUTOR, GET_ALL_SHIFT} from "@/core/services/store/tutor/tutor.module";

export default {
  name: "AddNewTutor",
  props:{
    levels:{
      type: Array,
      default(){
        return []
      }
    }
  },
  data() {
    return {
      okDisable: false,
      form: {
        staffSearch: '',
        level: '',
        zoomLink: '',
        meetLink: '',
        visible: true,
        fixedSchedule: true,
        zaloLink: '',
      },
      baseSchedule: [
        {
          name: 'Ca sáng',
          code: 'morning',
          timeNameRange: '08h00 - 12h00',
          isFullWeek: false,
          days: [
            {day: 'thứ 2', isWork: false},
            {day: 'thứ 3', isWork: false},
            {day: 'thứ 4', isWork: false},
            {day: 'thứ 5', isWork: false},
            {day: 'thứ 6', isWork: false},
            {day: 'thứ 7', isWork: false},
            {day: 'Chủ nhật', isWork: false}
          ]
        },
        {
          name: 'Ca chiều',
          isFullWeek: false,
          code: 'afternoon',
          timeNameRange: '13h30 - 17h30',
          days: [
            {day: 'thứ 2', isWork: false},
            {day: 'thứ 3', isWork: false},
            {day: 'thứ 4', isWork: false},
            {day: 'thứ 5', isWork: false},
            {day: 'thứ 6', isWork: false},
            {day: 'thứ 7', isWork: false},
            {day: 'Chủ nhật', isWork: false}
          ]
        },
        {
          name: 'Ca tối',
          isFullWeek: false,
          code: 'evening',
          timeNameRange: '18h00 - 22h00',
          days: [
            {day: 'thứ 2', isWork: false},
            {day: 'thứ 3', isWork: false},
            {day: 'thứ 4', isWork: false},
            {day: 'thứ 5', isWork: false},
            {day: 'thứ 6', isWork: false},
            {day: 'thứ 7', isWork: false},
            {day: 'Chủ nhật', isWork: false}
          ]
        }
      ],
      fixedWorkSchedule: [],
      loading: false,
      listStaff: [],
      shiftAll : [],
      loadingAdd: false
    };
  },
  methods: {
    handleCheckAll(isFullWeek, days) {
      days.forEach((day) => {
        day.isWork = isFullWeek
      })
    },
    handleChooseDay(shift) {
      shift.isFullWeek = shift.days.every(day => day.isWork === true);
    },
    async findStaff(query) {
      try {
        this.loading = true
        let staffs = await this.$store.dispatch(GET_USER_BY_PHONE, {
          phone: query
        })
        this.listStaff = staffs.data
      } catch (e) {
        this.listStaff = []
      } finally {
        this.loading = false
      }
    },
    async addNewTutor() {
      let payload = {
        user_id: this.form.staffSearch,
        type_id: 1,
        link_test: this.form.zoomLink,
        link_meet: this.form.meetLink,
        link_zalo: this.form.zaloLink,
        status: this.form.visible,
        admin_level_id: this.form.level,
        is_fixed_schedule: this.form.fixedSchedule,
        shifts: this.fixedWorkSchedule?.map((shift, shiftIndex) => {
          let shiftId = this.shiftAll.find(apiShift => apiShift.code === shift.code)?.id
          return {
            shift_id: shiftId,
            days: shift?.days?.map((day, dayIndex) => {
              return {
                day_of_week: dayIndex + 1,
                value: day?.isWork
              }
            })
          }
        })
      }
      this.loadingAdd = true
      try {
        await this.$store.dispatch(ADD_NEW_TUTOR, payload)
        this.$message({
          type:'success',
          showClose: true,
          message: 'Thêm gia sư thành công'
        });
        this.$bvModal.hide('create-tutor')
        this.$emit('loadList')
      } catch (e) {
        this.$message({
          showClose: true,
          message: `${e.data.message}`,
          type: 'error',
          duration: 6000
        });
      }finally {
        this.loadingAdd = false
      }

    },
    handleWhenStart() {
      this.form = {
        staffSearch: '',
        level: '',
        zoomLink: '',
        meetLink: '',
        visible: true,
        fixedSchedule: true,
        zaloLink: '',
      }
      this.fixedWorkSchedule = JSON.parse(JSON.stringify(this.baseSchedule))
      this.getAllShift()
    },
    closeModal(){
      this.$bvModal.hide('create-tutor')
    },
    async getAllShift(){
        const res = await this.$store.dispatch(GET_ALL_SHIFT)
        this.shiftAll = res.data??[]
    }

  }
}
</script>

<template>
  <b-modal id="create-tutor" title="Thêm mới nhân sự gia sư" hide-footer size="xl" @show="handleWhenStart">
    <ValidationObserver v-slot="{ handleSubmit }">
      <form class="form" autocomplete="off">
        <div class="container">
          <div class="row">
            <!-- Tìm nhân sự -->
            <div class="col-md-6">
              <div class="form-group">
                <label>Tìm nhân sự <span class="text-danger">*</span></label>
                <ValidationProvider name="Tìm nhân sự" rules="required" v-slot="{ errors }" vid="staff_search">
                  <el-select
                      placeholder="Nhập mã nhân sự, số điện thoại"
                      v-model="form.staffSearch"
                      filterable
                      remote
                      reserve-keyword
                      :remote-method="findStaff"
                      :loading="loading"
                      class="w-100">
                    <el-option
                        v-for="item in listStaff"
                        :key="item.id"
                        :label="item.name + ' - ' + item.phone"
                        :value="item.id">
                    </el-option>
                  </el-select>
                  <div class="fv-help-block" style="color: red; margin-top: 5px">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
            </div>
            <!-- Trình độ -->
            <div class="col-md-6">
              <div class="form-group">
                <label>Trình độ <span class="text-danger">*</span></label>
                <ValidationProvider name="Trình độ" rules="required" v-slot="{ errors }" vid="level235646">
                  <el-select v-model="form.level" placeholder="Chọn trình độ" clearable filterable class="w-100">
                    <el-option v-for="item in levels" :key="item.id" :label="item.name" :value="item.id"/>
                  </el-select>
                  <div class="fv-help-block" style="color: red; margin-top: 5px">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
            </div>

            <!-- Link Zoom -->
            <div class="col-md-6">
              <div class="form-group">
                <label>Link Zoom <span class="text-danger">*</span></label>
                <ValidationProvider name="Link Zoom" rules="required" v-slot="{ errors }" vid="zoom_link">
                  <el-input v-model="form.zoomLink" placeholder="Nhập link zoom" clearable/>
                  <div class="fv-help-block" style="color: red; margin-top: 5px">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
            </div>

            <!-- Link Meet -->
            <div class="col-md-6">
              <div class="form-group">
                <label>Link Meet <span class="text-danger">*</span></label>
                <ValidationProvider name="Link Meet" rules="required" v-slot="{ errors }" vid="meet_link">
                  <el-input v-model="form.meetLink" placeholder="Nhập link meet" clearable/>
                  <div class="fv-help-block" style="color: red; margin-top: 5px">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Link Zalo <span class="text-danger">*</span></label>
                <ValidationProvider name="Link Zalo" rules="required" v-slot="{ errors }" vid="zalo_link">
                  <el-input v-model="form.zaloLink" placeholder="Nhập link zalo" clearable/>
                  <div class="fv-help-block" style="color: red; margin-top: 5px">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
            </div>

            <!-- Hiển thị -->
            <div class="col-md-12 mt-2 row">
              <el-switch class="col-md-6" v-model="form.visible" active-text="Hiển thị / Ẩn"/>
              <el-switch class="col-md-6" v-model="form.fixedSchedule" active-text="Lịch làm việc cố định"/>
            </div>
          </div>
          <div class="mt-5" v-if="form.fixedSchedule">
            <p>Lịch làm việc cố định</p>
            <div class="table-container">
              <table class="table table-bordered text-center align-middle">
                <thead class="thead-light">
                <tr>
                  <th>Ca làm việc</th>
                  <th>Tất cả</th>
                  <th>Thứ 2</th>
                  <th>Thứ 3</th>
                  <th>Thứ 4</th>
                  <th>Thứ 5</th>
                  <th>Thứ 6</th>
                  <th>Thứ 7</th>
                  <th>Chủ nhật</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="shift in fixedWorkSchedule" :key="shift.name">
                  <td>{{ shift.name }} <span style="color: grey"> ({{ shift.timeNameRange }})</span></td>
                  <td>
                    <el-checkbox v-model="shift.isFullWeek"
                                 @change="handleCheckAll(shift.isFullWeek,shift.days)"></el-checkbox>
                  </td>
                  <td v-for="day in shift.days">
                    <el-checkbox v-model="day.isWork" @change="handleChooseDay(shift)"></el-checkbox>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="d-flex justify-content-end mt-10">
            <button type="button" class="btn btn-secondary mr-4" @click="closeModal" :disabled="loadingAdd">Hủy bỏ</button>
            <button type="button" class="btn btn-primary" @click="handleSubmit(addNewTutor)" :disabled="loadingAdd" > <i v-if="loadingAdd" class="el-icon-loading"></i>Xác nhận</button>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </b-modal>
</template>

<style scoped>

</style>